// File: frontend/src/components/Admin/LineServicesCard.jsx

import React, { useState, useEffect } from 'react';
import LineSettingsModal from './LineSettingsModal';
import LinePaySettingsModal from './LinePaySettingsModal';
import { lineAPI, linePayAPI } from '../../services/api';

export default function LineServicesCard() {
  const [isBotModalOpen, setIsBotModalOpen] = useState(false);
  const [isPayModalOpen, setIsPayModalOpen] = useState(false);

  // LINE Official Status
  const [hasBotToken, setHasBotToken] = useState(false);

  // LINE Pay Status
  const [payEnabled, setPayEnabled] = useState(false);
  const [hasPayQr, setHasPayQr] = useState(false);

  const fetchStatuses = async () => {
    try {
      const [botData, payData] = await Promise.allSettled([
        lineAPI.getSettings(),
        linePayAPI.getSettings()
      ]);

      if (botData.status === 'fulfilled' && botData.value) {
        setHasBotToken(Boolean(botData.value.has_token));
      }

      if (payData.status === 'fulfilled' && payData.value) {
        setPayEnabled(Boolean(payData.value.line_pay_enabled));
        setHasPayQr(Boolean(payData.value.line_pay_qr_image_url));
      }
    } catch (err) {
      // Ignored for non-critical status polling
    }
  };

  useEffect(() => {
    fetchStatuses();
  }, [isBotModalOpen, isPayModalOpen]);

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 flex flex-col justify-between hover:border-gray-200 transition-colors">
      <div>
        <div className="flex justify-between items-center mb-1">
          <h3 className="font-bold text-gray-800 dark:text-gray-200 flex items-center gap-1.5 text-sm">
            <span className="text-emerald-500 font-bold">💬</span> LINE Services
          </h3>
          <div className="flex items-center gap-1">
            <span
              className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${
                hasBotToken ? 'bg-green-100 text-green-800' : 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400'
              }`}
              title={hasBotToken ? 'LINE Bot Messaging API Connected' : 'LINE Bot Not Connected'}
            >
              {hasBotToken ? '🟢 Bot' : '⚪ Bot'}
            </span>
            <span
              className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${
                payEnabled ? 'bg-emerald-100 text-emerald-800' : 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400'
              }`}
              title={payEnabled ? (hasPayQr ? 'LINE Pay & QR Active' : 'LINE Pay Enabled') : 'LINE Pay Disabled'}
            >
              {payEnabled ? (hasPayQr ? '💳 Pay QR' : '💳 Pay') : '⚪ Pay'}
            </span>
          </div>
        </div>
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">
          Manage LINE Official Account bot alerts & LINE Pay / iPASS MONEY QR code payments in one place.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-2 mt-auto">
        <button
          type="button"
          onClick={() => setIsBotModalOpen(true)}
          className="w-full bg-green-600 hover:bg-green-700 text-white text-xs font-bold py-2 px-2 rounded-lg transition-colors shadow-xs flex items-center justify-center gap-1 cursor-pointer truncate"
          title="Configure LINE Official Account & Messaging Bot"
        >
          <span>🤖</span>
          <span className="truncate">Official Bot</span>
        </button>

        <button
          type="button"
          onClick={() => setIsPayModalOpen(true)}
          className="w-full bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold py-2 px-2 rounded-lg transition-colors shadow-xs flex items-center justify-center gap-1 cursor-pointer truncate"
          title="Configure LINE Pay / QR Code Receipt"
        >
          <span>💳</span>
          <span className="truncate">LINE Pay</span>
        </button>
      </div>

      {/* Modals */}
      <LineSettingsModal isOpen={isBotModalOpen} onClose={() => setIsBotModalOpen(false)} />
      <LinePaySettingsModal isOpen={isPayModalOpen} onClose={() => setIsPayModalOpen(false)} />
    </div>
  );
}
